export default __webpack_public_path__ + "img/60be7cc45a4355d05e7916592fa8e811.svg";